module.exports = __webpack_public_path__ + "img/PS22.958dfe05.png";